module.exports = __webpack_public_path__ + "static/media/address_proof_rear.5470c9ae.svg";